import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

const StyledHeading = styled('h1')(({ theme }) => ({
  background: '-webkit-linear-gradient(#008B5E 0%, #006041 100%)',
  // '-webkit-background-clip': 'text',
  WebkitBackgroundClip: 'text',
  color: 'rgba(0,0,0,0)',
  textAlign: 'center',
  fontSize: 74,
  fontWeight: 'bold',
  lineHeight: '90px',
  margin: 0,
  [theme.breakpoints.down('sm')]: {
    fontSize: 35,
    lineHeight: 1.4,
  },
}));

const AboutHeader = () => {
  return (
    <Box pt="156px" pb="70px">
      <StyledHeading>
        We are Democratizing
        <br />
        Fundraising in India
      </StyledHeading>
      <Typography
        component="p"
        color="rgba(17, 17, 17, 0.7)"
        fontSize="22px"
        align="center"
        fontWeight="normal"
        lineHeight="34px"
        sx={{
          pt: '34px',
          '& span': {
            color: '#111',
            fontWeight: 'bold',
          },
        }}
      >
        POD is a Bengaluru-based fundraising platform.
        <br />
        Founded by <span>Vittal Ramakrishna</span> and backed by
        <span> Elina Investments,</span>
        <br />
        the platform aspires to nurture a
        <br />
        healthy ecosystem for investing and fundraising.
      </Typography>
    </Box>
  );
};

export default AboutHeader;
